import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';

export let alt = ['P2', 'E2', 'E8', 'B1']
  
export function rules_headc(newState, state) {
  let slist = state['options_sh'].options.flatMap(x => x['value']).filter(n => !alt.includes(n))
  var newrule = includeRule(newState, state, 'headc')
   
    newrule = excludeRule(newState, state, [
        ['sh', slist],
        ['headc', ['0', 'AQ', 'LBT', 'MG', 'TZ']]], newrule)
    //    console.log("alt",alt)
    
    newrule = excludeRule(newState, state, [
        ['sh', alt],
        ['headc', ['0', 'D', 'GA', 'SAP', 'EM', 'RU']]], newrule)
    newrule = excludeRule(newState, state, [
          ['sh', ['R12']],
          ['headc', ['D']]], newrule)
  

    newrule = excludeRule(newState, state, [
        ['sh', ['E8']],
        ['headc', ['AQ', 'MG', 'LBT', 'TZ']]], newrule)

    


        //['0','AM','AQ','CT','LBT','RH','PT','PZ','TZ','WT'],  // 1 - center stone color
        //['0','AM','AQ','CT','EM','GA','LBT','MG','PT','PZ','RU','SAP','TZ','WT','D'],  // 5 - head stones color
        
    return newrule
}



// WEBPACK FOOTER //
// ./src/reducers/rules_headc.js